export const tagsOptions = {
  name: 'tags',
  options: () => ({
    fetchPolicy: 'network-only'
  })
};
